/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_PricingInputs */

const en_directory_nav_pricing = /** @type {(inputs: Directory_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_directory_nav_pricing = /** @type {(inputs: Directory_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Directory_Nav_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_pricing = /** @type {((inputs?: Directory_Nav_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_pricing(inputs)
	return zh_directory_nav_pricing(inputs)
});
export { directory_nav_pricing as "directory.nav.pricing" }